// Path: src\Components\WorldOfEports\WorldOfEsports.jsx
import React, { useEffect, useHistory, useState } from "react";
import BaseHome from "../Home/BaseHome";
import LevelIcon from "../../assets/images/level.png";
import Newsimg from "../../assets/images/gamenews.jpeg";
import { useNavigate } from "react-router-dom";
import {
  getFeaturedVideo,
  getTopProfiles,
  getBlogs,
  getFollowers,
} from "../../api/worldOfEsports.api";
import { url } from "../../config/url";
import User from "../../assets/images/user-icon.svg";
import ListLoader from "../Common/ListLoader";
import { t } from "i18next";

const WorldOfEsports = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [featuredVideoList, setFeaturedVideoList] = useState([]);
  const [popularVideoList, setPopularVideoList] = useState([]);
  const [topProfileList, setTopProfileList] = useState([]);
  const [blogList, setBlogList] = useState([]);

  const handleRedirect = (e) => {
    e.preventDefault(); // Prevent the default link behavior
    navigate("/world-of-eports/popularvideos"); // Redirect to the desired route
  };
  const handleRedirectNews = (e) => {
    e.preventDefault(); // Prevent the default link behavior
    navigate("/world-of-eports/esports-news"); // Redirect to the desired route
  };
  const handleRedirectProfile = (e) => {
    e.preventDefault(); // Prevent the default link behavior
    navigate("/world-of-eports/user-profile"); // Redirect to the desired route
  };

  useEffect(() => {
    fetchFeaturedVideoList();
    fetchPopularVideoList();
    fetchTopProfileList();
    fetchBlogList();
  }, []);

  const fetchFeaturedVideoList = async () => {
    setLoading(true);
    try {
      const data = {
        pagination: {
          pageNo: 1,
          recordPerPage: 1,
          sortBy: "order",
          sortDirection: "desc",
        },
        search: {
          isLive: true,
        },
      };
      const res = await getFeaturedVideo(data);
      setLoading(false);
      if (res?.success && res?.data) {
        setFeaturedVideoList(res?.data);
      } else {
        setFeaturedVideoList([]);
      }
    } catch (error) {
      setFeaturedVideoList([]);
    }
  };

  const fetchPopularVideoList = async () => {
    try {
      const res = await getFeaturedVideo({
        pagination: {
          pageNo: 1,
          recordPerPage: 2,
          sortBy: "order",
          sortDirection: "desc",
        },
        search: {
          isLive: false,
        },
      });
      if (res?.success && res?.data) {
        setPopularVideoList(res?.data);
      } else {
        setPopularVideoList([]);
      }
    } catch (error) {
      setPopularVideoList([]);
    }
  };

  const videoUrls = (url) => {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url?.match(regExp);

    if (match?.length > 0) {
      let videoId = match && match[2].length === 11 ? match[2] : null;

      return "//www.youtube.com/embed/" + videoId;
    }
    return "";
  };

  const fetchTopProfileList = async () => {
    try {
      const res = await getTopProfiles({
        flag: true,
      });
      if (res?.success && res?.data) {
        setTopProfileList(res?.data);
      } else {
        setTopProfileList([]);
      }
    } catch (error) {
      setTopProfileList([]);
    }
  };

  const fetchBlogList = async () => {
    try {
      const res = await getBlogs({
        pagination: {
          pageNo: 1,
          recordPerPage: 3,
          sortBy: "createdAt",
          sortDirection: "desc",
        },
      });
      if (res?.success && res?.data) {
        setBlogList(res?.data);
      } else {
        setBlogList([]);
      }
    } catch (error) {
      setBlogList([]);
    }
  };

  const handleFollowToggle = async (profileId, isFollow, currentFollowers) => {
    const action = isFollow ? "unfollow" : "follow";
    const followingUser = profileId;

    try {
      const res = await getFollowers({
        action,
        followingUser,
      });

      if (res?.success) {
        // Update the follower count and follow state
        setTopProfileList((prevList) =>
          prevList.map((profile) => {
            if (profile._id === profileId) {
              return {
                ...profile,
                isFollow: !isFollow,
                followers: isFollow
                  ? currentFollowers - 1
                  : currentFollowers + 1, // Adjust follower count
              };
            }
            return profile;
          })
        );
      }
    } catch (error) {
      console.error("Failed to toggle follow state", error);
    }
  };

  const handleArticleClick = (id) => {
    navigate(`/world-of-eports/detail/${id}`); // Navigate to the detail page with the blog ID
  };

  const openPopularVideo = (id, name, url) => {
    navigate("/world-of-eports/popularvideo", {
      state: { id, name, url },
    })
  }

  return (
    <BaseHome
      isFooter={true}
      title={t("woe.world_of_esports")}
      notBack={true}
      MaxFullPageScroll={true}
    >
      <div className="world-of-esports-main-wrap">
        <div className="world-of-esports-inner-wrap">
          {/* featured video */}
          {featuredVideoList?.length > 0 && (
            <>
              <div className="world-of-esports-feature-video-text">
                {t("woe.featured_videos")}
              </div>
              {featuredVideoList.map(
                (data, indp) =>
                  data?.url &&
                  videoUrls(data?.url) && (
                    <div className="world-of-esport-box mt-4">
                      <div className="world-of-esport-heading" style={{textTransform:"lowercase",fontSize:"16px"}}>
                        {data?.name?.length > 20 ? (
                          <marquee>{data?.name}</marquee>
                        ) : (
                          data?.name
                        )}
                      </div>
                      <hr></hr>
                      <div className="world-of-esports-youtube-box">
                        <iframe
                          width="100%"
                          height="170px"
                          src={videoUrls(data?.url)}
                          title={data?.name}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>
                  )
              )}
            </>
          )}

          {/* popular video */}
          {popularVideoList?.length > 0 && (
            <>
              <div className="world-of-esports-popular-videos-flex mt-4">
                <div className="world-of-esports-popular-videos">
                  {popularVideoList.length === 1
                    ? t("woe.popular_video")
                    : t("woe.popular_videos")}
                </div>
                <div className="world-of-esports-view-all">
                  <a
                    href="#"
                    onClick={handleRedirect}
                    rel="noopener noreferrer"
                    className='a-link-color'
                  >
                    {t("woe.view_all")}
                  </a>
                </div>
              </div>

              <div className="world-of-esports-popularvideobox mt-4">
                <div className="world-of-esports-video-row">
                  {popularVideoList.map(
                    (data, indp) =>
                      data?.url &&
                      videoUrls(data?.url) && (
                        <div className="world-of-esports-popularvideobox-innerwrap">
                          <div className="world-of-esports-popularvideo-inner-box">
                            {/* <iframe
                              width="100%"
                              height="95px"
                              src={videoUrls(data?.url)}
                              title={data?.name}
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                            ></iframe> */}
                            <div style={{ position: "relative", width: "100%", height: "95px" }}>
                              <iframe
                                width="100%"
                                height="95px"
                                src={videoUrls(data?.url)}
                                title={data?.name}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                              ></iframe>
                              <div
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  background: "transparent",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  openPopularVideo(data?._id, data?.name, data?.url)
                                }}
                              ></div>
                            </div>
                          </div>
                          <div className="world-of-esports-inner-video-title">
                            {data?.name?.length > 24 ? (
                              <marquee>{data?.name}</marquee>
                            ) : (
                              data?.name
                            )}
                          </div>
                        </div>
                      )
                  )}
                </div>
              </div>
            </>
          )}

          {/* top profile */}
          {topProfileList?.length > 0 && (
            <>
              <div className="world-of-esports-popular-videos-flex mt-4">
                <div className="world-of-esports-popular-videos">
                  {topProfileList.length === 1
                    ? t("woe.top_profile")
                    : t("woe.top_profiles")}
                </div>
                <div className="world-of-esports-view-all">
                  <a
                    href="#"
                    onClick={handleRedirectProfile}
                    rel="noopener noreferrer"
                    className='a-link-color'
                  >
                    {t("woe.view_all")}
                  </a>
                </div>
              </div>
              <div className="world-of-esports-player-profile profilemargin">
                <div className="world-of-esports-profile-wrap">
                  {topProfileList.slice(0, 3).map((data, indp) => (
                    <div
                      className="world-of-esports-player-profile-container"
                      key={indp}
                    >
                      {data?.level ? (
                        <div
                          className="world-of-esports-player-profile-circle"
                          style={{ cursor: "pointer" }}
                          onClick={() => navigate("/user-profile/" + data?._id)}
                        >
                          <img
                            className="world-of-esport-player-img"
                            src={url?.IMAGE_URL + data?.level}
                            alt="Player"
                          />
                        </div>
                      ) : (
                        <div
                          className="world-of-esports-player-profile-circle"
                          style={{ cursor: "pointer" }}
                          onClick={() => navigate("/user-profile/" + data?._id)}
                        >
                          <img
                            className="world-of-esport-player-img"
                            src={User}
                            alt="Player"
                          />
                        </div>
                      )}
                      <div className="world-of-esports-player-info">
                        <h2 className="world-of-esports-player-name">
                          {data?.gamerjiName?.length > 13 ? (
                            <marquee>
                              {data?.gamerjiName}
                            </marquee>
                          ) : (
                            data?.gamerjiName
                          )}
                        </h2>
                        <p className="world-of-esports-player-followers">
                          {data?.followers === 0
                            ? "0 follower"
                            : data?.followers === 1
                            ? "1 follower"
                            : `${data?.followers} followers`}
                        </p>
                      </div>
                      <button
                        className="world-of-esports-follow-btn"
                        onClick={() =>
                          handleFollowToggle(
                            data._id,
                            data?.isFollow,
                            data.followers
                          )
                        }
                      >
                        {data?.isFollow ? "Following" : "Follow"}
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}

          {/* esports news */}
          {blogList?.length > 0 && (
  <>
    <div className="world-of-esports-popular-videos-flex mt-4">
      <div className="world-of-esports-popular-videos">
        {t("woe.esports_news")}
      </div>
      <div className="world-of-esports-view-all">
        <a
          href="#"
          onClick={handleRedirectNews}
          rel="noopener noreferrer"
          className='a-link-color'
        >
          {t("woe.view_all")}
        </a>
      </div>
    </div>
    <div className="esports-news-cointner mt-4">
      {blogList.slice(0, 2).map((data, indp) => (
        <div
          className="esports-news-card"
          style={{ minWidth: "48.50%" }}
          key={indp}
          onClick={() => handleArticleClick(data._id)}
        >
          <div className="esports-news-image">
            <img
              src={url?.IMAGE_URL + data?.img}
              alt={data?.title}
            ></img>
          </div>
          <div className="esports-news-content">
            {data?.title?.length > 10 ? (
              <marquee>{data?.title}</marquee>
            ) : (
              data?.title
            )}
            <p className="esports-news-body">
              {data?.shortDescription}
            </p>
          </div>
        </div>
      ))}
    </div>
  </>
)}

          {loading && (
            <div className="w-100 d-flex justify-content-center">
              {" "}
              <ListLoader />
            </div>
          )}
        </div>
      </div>
    </BaseHome>
  );
};

export default WorldOfEsports;
